const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5001";
// console.log("🌍 API_BASE_URL =", API_BASE_URL);

export default API_BASE_URL;
